<template>
  <v-dropdown
    v-if="subscriber.isLogged"
    class="c-navbar-subscriber"
    :aria-label="$t('accessibility.account.open')"
  >
    <template #activator>
      <i class="o-icon o-icon--user o-typography--action"></i>
    </template>
    <router-link
      v-if="!subscriber.isKidsTheme"
      :to="{ name: RouteName.SUBSCRIBER_MY_ACCOUNT }"
      class="o-typography--action"
    >
      {{ $t('glossary.myAccount') }}
    </router-link>
    <div
      v-accessibility-focus="logout"
      class="o-typography--action"
    >
      {{ $t('common.signOut') }}
    </div>
  </v-dropdown>
  <router-link
    v-else
    :event="$route.name !== RouteName.SUBSCRIBER_LOGIN ? 'click' : ''"
    :to="{ name: RouteName.SUBSCRIBER_LOGIN, query: { redirect: $route.fullPath }}"
    class="o-typography--action u-bold"
  >
    {{ $t('common.login') }}
  </router-link>
</template>
<script>
  import { RouteName } from '@/shared/enums';
  import { VDropdown } from '@/index/shared/components';

  export default {
    components: {
      VDropdown,
    },
    enums: {
      RouteName,
    },
    data() {
      return {
        subscriber: this.$services.resolve('subscriber'),
      };
    },
    methods: {
      logout() {
        this.$spinner.show();
        this.subscriber.logout()
          .then(() => this.$router.replace({ name: RouteName.HOME }))
          .catch(() => {});
      },
    },
  };
</script>
